import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Loads the feed if it is currently empty
 */
export const startLoadOnViewIfNeeded = store.effects.create(
  (feature: Feature) =>
    feature.actions.viewFeed.observe().pipe(
      // We only need to load if we currently have an empty feed
      rxjsUtils.onlyWhen(
        feature.selectors.feed.asObservable.pipe(
          rxjs.map(feed => !feed.length),
        ),
      ),
      rxjs.map(action => feature.actions.loadFeed.from(action).create()),
    ),
)
